import { FC } from 'react';
import { TextInput, TextInputProps, useTranslate, Validator } from 'react-admin';

import { createPhoneNumberValidator } from '@sh4res/bo-common/validators/phoneNumberValidator';

interface PhoneNumberInputProps extends TextInputProps {
  mobileOnly?: boolean;
  testId?: string;
}

export const PhoneNumberInput: FC<PhoneNumberInputProps> = ({
  mobileOnly,
  testId,
  validate,
  ...props
}) => {
  const translate = useTranslate();
  const phoneNumberValidator = createPhoneNumberValidator(translate, { mobileOnly });
  const extraValidators = ([] as Validator[]).concat(validate ?? []);
  const validators = [...extraValidators, phoneNumberValidator];

  return (
    <TextInput
      {...props}
      data-testid={testId}
      validate={validators}
      placeholder={props.placeholder || '+33xxxxxxxxx'}
      type="tel"
    />
  );
};
